import { supabase } from '@/core/database/supabase';
import type { ConstructionBoqItem } from '../types/construction-boq.types';

export const ConstructionBoqImportService = {
  async bulkCreateBoqItems(items: Partial<ConstructionBoqItem>[]) {
    const { error } = await supabase
      .from('construction_boq_items')
      .insert(items);

    if (error) throw error;
  }
};
